var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"borrowingStatus"},[_c('div',{staticClass:"borrowingStatus-box"},[_vm._m(0),_c('div',{staticClass:"txt"},[_vm._v("借物成功")]),_c('div',{staticClass:"btn",on:{"click":_vm.returnIndex}},[_vm._v("返回")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("./img/res.png"),"alt":""}})])
}]

export { render, staticRenderFns }